import axios from 'axios';
import AppSettings from '../appSettings.json';
import { authInterceptor } from './interceptor';

const axiosInstance = axios.create({
	baseURL: `${AppSettings.apiUrl}`,
});
axiosInstance.interceptors.request.use(authInterceptor as any);
export default axiosInstance;
